import React, { FC, PropsWithChildren } from 'react';
import { Typography } from 'fronton-react';
import { subscribeLink } from './styles';

type Props = {
  href: string;
  noreferrer?: boolean;
};

export const SubscribeLink: FC<PropsWithChildren<Props>> = ({ href, noreferrer, children }) => (
  <a href={href} rel={noreferrer ? 'noopener noreferrer' : 'noopener'}>
    <Typography variant="minor" size="caption" className={subscribeLink}>
      {children}
    </Typography>
  </a>
);
